import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * Dropdown - A wrapper that renders a standard HTML div with Bulma class names
 *
 * This component accepts the same props as Bloomer Dropdown for easy migration
 */
const Dropdown = ({ className, children, style, isActive, isAlign, isRight, isUp, ...props }) => {
  // Build the class names based on props
  const getClassNames = () => {
    return classNames('dropdown', {
      'is-active': isActive,
      'is-right': isRight || isAlign === 'right',
      'is-up': isUp,
      [className]: className,
    });
  };

  return (
    <div className={getClassNames()} style={style} {...props}>
      {children}
    </div>
  );
};

Dropdown.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
  isActive: PropTypes.bool,
  isAlign: PropTypes.string,
  isRight: PropTypes.bool,
  isUp: PropTypes.bool,
};

Dropdown.defaultProps = {
  className: '',
  style: {},
  children: null,
  isActive: false,
  isAlign: null,
  isRight: false,
  isUp: false,
};

export default Dropdown;
